<template>
    <v-container>
    <v-card style="border-radius: 8px;">
        <v-layout>
            <v-flex xs4 class="ml-5 mt-3 mb-1">
                <div class="title font-weight-regular"> Templates</div>
            </v-flex>
            <v-flex xs8 class="mt-3 mb-3">
                <div class="title font-weight-regular"> Messages</div>
            </v-flex>
        </v-layout>

        <v-layout>
            <v-flex xs4 class="scroll-y ml-3" style="max-height:280px">
                <v-card flat class="mt-3 ml-3">
                     <v-list>
                        <template v-for="(bmessage, index) in cMessages">
                            <v-list-tile                                
                                style="cursor: pointer;"
                                :key="index+'a'"
                                :color="bmessage.active ? 'primary' : ''"
                                >
                                <v-list-tile-content>
                                    <v-list-tile-title @click="expandTemplate(index)" @mouseover="openmenu(index)" class="body-1 font-weight-regular">{{ bmessage.name }}</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="hover1 == index">
                                    <v-card-actions @mouseleave="closemenu">
                                        <v-btn @click="editTemplateName(index,$event,'edittemplate')" flat icon color="grey">
                                                <v-icon small>edit</v-icon>
                                        </v-btn>    
                                        <v-btn @click="deleteTemplate(index)" flat icon color="grey">
                                                <v-icon small>delete</v-icon>
                                        </v-btn>
                                        <v-btn @click="expandTemplate(index)" flat icon color="grey lighten-1">
                                            <v-icon small>keyboard_arrow_right</v-icon>
                                        </v-btn>
                                    </v-card-actions>    
                                </v-list-tile-action>
                            </v-list-tile>                                   
                            <v-divider
                                v-if="index + 1 < cMessages.length"
                                :key="index+'b'"
                            ></v-divider>
                        </template>
                    </v-list>                    
                </v-card>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex  xs7 class="scroll-y" style="max-height: 280px">
                <template v-for="(card, index) in cards">
                    <v-layout :key="index" @mouseleave="hidebuttons()">
                        <v-flex xs1 class="mt-2"> 
                            <v-layout>   
                            <v-btn
                                v-if="button1 == index && card.type == 'generic'"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                                @click="moveleft(index)"
                            >
                            <v-icon>chevron_left</v-icon>                                    
                            </v-btn> 
                            </v-layout>                          
                        </v-flex>
                        <v-flex xs5 class="ma-0" @mouseover="showbuttons(index)">                            
                            <v-card v-if="card.type == 'text'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title  class="body-1 font-weight-regular mt-3">
                                    <div>
                                        <h3 class="body-1">{{card.message.text}}</h3>
                                        <!-- <h3 class="body-1">{{card.message.dynamic_text.text}}</h3>
                                        <div class="caption grey--text">{{card.message.dynamic_text.fallback_text}}</div> -->
                                    </div>
                                </v-card-title>
                            </v-card>
                            <v-card v-if="card.type == 'button'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title class="body-1 font-weight-regular mt-3"> {{card.message.attachment.payload.text}}</v-card-title>
                                <v-flex>
                                    <v-tooltip bottom v-for="(button,tbindex) in card.message.attachment.payload.buttons" :key="tbindex">
                                        <template v-slot:activator="{ on }">
                                        <v-btn small depressed block round color="white" v-on="on">{{button.title}}</v-btn>
                                        </template>
                                    <span v-if="button.type == 'phone_number'">Phone number: {{button.payload}}</span>
                                    <span v-if="button.type == 'postback'">Link to response:{{button.payload}}</span>
                                    <span v-if="button.type == 'web_url'">url: {{button.url}} <br> webview height: {{button.webview_height_ratio}}</span>
                                    </v-tooltip>
                                </v-flex> 
                            </v-card>
                            <v-card v-if="card.type == 'image' || card.type == 'video' || card.type == 'audio' || card.type =='file'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title v-if="card.uploadtype == 'asset'" class="body-1 font-weight-regular mt-3">
                                 <span>Message type: {{card.type}}<br>Assest: {{card.name}}</span> 
                                </v-card-title>
                                <v-card-title v-if="card.uploadtype == 'url' && (card.type == 'video'|| card.type == 'audio' || card.type == 'file')" class="body-1 font-weight-regular mt-3">
                                 <span class="text-truncate">Message type: {{card.type}}<br>URL: {{card.message.attachment.payload.url}}</span> 
                                </v-card-title>
                                <v-img
                                    v-if="card.uploadtype == 'url' && card.type == 'image'"
                                    :src="card.message.attachment.payload.url"
                                >
                                </v-img>
                            </v-card>
                            <v-card v-if="card.type == 'media'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <v-card-title v-if="card.uploadtype == 'asset'" class="body-1 font-weight-regular mt-3">
                                 <span>Message type: {{card.mediatype}}<br>Assest: {{card.name}}</span> 
                                </v-card-title>
                                <v-card-title v-if="card.uploadtype == 'url' && (card.mediatype == 'video' || card.mediatype == 'image')" class="body-1 font-weight-regular mt-3">
                                 <span class="text-truncate">Message type: {{card.mediatype}}<br>URL: {{card.message.attachment.payload.elements[0].url}}</span> 
                                </v-card-title>
                                <v-flex v-if="card.button=='Yes'">
                                    <v-tooltip bottom v-for="(button,mindex) in card.message.attachment.payload.elements[0].buttons" :key="mindex">
                                        <template v-slot:activator="{ on }">
                                        <v-btn v-if="button.type != 'element_share'" small depressed block round color="white" v-on="on">{{button.title}}</v-btn>
                                        <v-btn v-if="button.type == 'element_share'" small depressed block round color="white" v-on="on">Share</v-btn>
                                        </template>
                                    <span v-if="button.type == 'phone_number'">Phone number: {{button.payload}}</span>
                                    <span v-if="button.type == 'element_share'">Sharble button</span>
                                    <span v-if="button.type == 'postback'">Link to response: {{button.payload}}</span>
                                    <span v-if="button.type == 'web_url'">url: {{button.url}} <br> webview height: {{button.webview_height_ratio}}</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-card>                            
                            <v-card v-if="card.type == 'generic'" flat style="border-radius: 8px;" class="ma-0 blue-grey lighten-5">
                                <template v-for="(gallerycard, cindex) in card.message.attachment.payload.elements">
                                    <v-card v-if="card.currentelement == cindex" :key="cindex"  flat style="border-radius: 8px;" class="ma-0 blue lighten-5">                                    
                                        <v-img
                                            :src="gallerycard.image_url"
                                            :aspect-ratio="card.message.attachment.payload.image_aspect_ratio == 'square' ? '1':'1.91'"
                                        >
                                        </v-img>
                                        <div class="body-1 font-weight-regular ml-2 mr-2 mt-2">{{gallerycard.title}}</div> 
                                        <div class="caption font-weight-regular grey--text ml-2 mr-2">{{gallerycard.subtitle}}</div>
                                        <div class="caption font-weight-regular grey--text ml-2 mr-2" v-if="card.imageaction[cindex]">{{gallerycard.default_action.url}}</div>
                                        <v-flex>
                                            <v-tooltip bottom v-for="(button,bindex) in gallerycard.buttons" :key="bindex">
                                                <template v-slot:activator="{ on }">
                                                <v-btn v-if="button.type != 'element_share'" small depressed block round color="white" v-on="on">{{button.title}}</v-btn>
                                                <v-btn v-if="button.type == 'element_share'" small depressed block round color="white" v-on="on">Share</v-btn>
                                                </template>
                                            <span v-if="button.type == 'phone_number'">Phone number: {{button.payload}}</span>
                                            <span v-if="button.type == 'element_share'">Sharble button</span>
                                            <span v-if="button.type == 'postback'">Link to response: {{button.payload}}</span>
                                            <span v-if="button.type == 'web_url'">url: {{button.url}} <br> webview height: {{button.webview_height_ratio}}</span>
                                            </v-tooltip>
                                        </v-flex>                                         
                                    </v-card>
                                </template>                             
                            </v-card>
                            <v-card v-if="card.type == 'list'" flat style="border-radius: 8px;" class="ma-0 mt-4 blue-grey lighten-5">
                                <template v-for="(listitem, listindex) in card.message.attachment.payload.elements">
                                <div v-if="card.message.attachment.payload.top_element_style == 'large' && listindex == 0 " :key="listindex+'a'" row>
                                    <v-card flat style="border-radius: 8px;">
                                        <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                        <v-img
                                            v-on="on"
                                            :src="listitem.image_url" 
                                            aspect-ratio="1.91"
                                        >
                                        <div class="ml-2 mt-3"> 
                                        <div class="caption font-weight-bold text-truncate ml-2">{{listitem.title}}</div>
                                        <div class="caption text-truncate ml-2">{{listitem.subtitle}}</div>
                                        <div v-if="card.listbuttonstatus[listindex] == true">
                                            <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-on="on" small outline color="primary">{{listitem.buttons[0].type =='element_share' ? 'Share':listitem.buttons[0].title}}</v-chip>
                                            </template>
                                            <span v-if="listitem.buttons[0].type == 'phone_number'">Phone number: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'element_share'">Sharble button</span>
                                            <span v-if="listitem.buttons[0].type == 'postback'">Link to response: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == true">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{listitem.buttons[0].messenger_extensions}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == false ">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                        </v-img>
                                        </template>
                                            <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == true">url: {{listitem.default_action.url}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: {{listitem.default_action.messenger_extensions}}</span>
                                            <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == false">url: {{listitem.default_action}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: false</span>
                                            <span v-if="card.imageaction[listindex] == false">Click action disabled</span>
                                        </v-tooltip>
                                    </v-card>
                                </div>
                                <v-layout v-if="card.message.attachment.payload.top_element_style == 'large' && listindex > 0 " :key="listindex+'b'" row>
                                    <v-flex xs7>
                                        <div class="ml-2"> 
                                        <div class="caption font-weight-bold text-truncate ml-2">{{listitem.title}}</div>
                                        <div class="caption text-truncate ml-2">{{listitem.subtitle}}</div>
                                        <div v-if="card.listbuttonstatus[listindex] == true">
                                            <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-on="on" small outline color="primary">{{listitem.buttons[0].type =='element_share' ? 'Share':listitem.buttons[0].title}}</v-chip>
                                            </template>
                                            <span v-if="listitem.buttons[0].type == 'phone_number'">Phone number: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'element_share'">Sharble button</span>
                                            <span v-if="listitem.buttons[0].type == 'postback'">Link to response: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == true">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{listitem.buttons[0].messenger_extensions}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == false ">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="card.imageurlstatus[listindex] == true" xs5>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-img
                                            v-on="on"
                                            style="border-radius: 8px;"
                                            class="mr-2"
                                            :src="listitem.image_url" 
                                            aspect-ratio="1"
                                        ></v-img>
                                        </template>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == true">url: {{listitem.default_action.url}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: {{listitem.default_action.messenger_extensions}}</span>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == false">url: {{listitem.default_action}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: false</span>
                                        <span v-if="card.imageaction[listindex] == false">Click action disabled</span>
                                    </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="card.message.attachment.payload.top_element_style == 'compact'" :key="listindex+'c'" row>
                                    <v-flex xs7>
                                        <div class="ml-2"> 
                                        <div class="caption font-weight-bold text-truncate ml-2">{{listitem.title}}</div>
                                        <div class="caption text-truncate ml-2">{{listitem.subtitle}}</div>
                                        <div v-if="card.listbuttonstatus[listindex] == true">
                                            <v-tooltip  bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-on="on" small outline color="primary">{{listitem.buttons[0].type =='element_share' ? 'Share':listitem.buttons[0].title}}</v-chip>
                                            </template>
                                            <span v-if="listitem.buttons[0].type == 'phone_number'">Phone number: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'element_share'">Sharble button</span>
                                            <span v-if="listitem.buttons[0].type == 'postback'">Link to response: {{listitem.buttons[0].payload}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == true">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{listitem.buttons[0].messenger_extensions}}</span>
                                            <span v-if="listitem.buttons[0].type == 'web_url' && card.extentionstatus.listbutton[listindex] == false ">url: {{listitem.buttons[0].url}} <br> webview height: {{listitem.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                        </v-tooltip>
                                        </div>
                                        </div>
                                    </v-flex>
                                    <v-flex v-if="card.imageurlstatus[listindex] == true" xs5>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                        <v-img
                                            v-on="on"
                                            style="border-radius: 8px;"
                                            class="mr-2"
                                            :src="listitem.image_url" 
                                            aspect-ratio="1"
                                        ></v-img>
                                        </template>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == true">url: {{listitem.default_action.url}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: {{listitem.default_action.messenger_extensions}}</span>
                                        <span v-if="card.imageaction[listindex] == true && card.extentionstatus.imageaction[listindex] == false">url: {{listitem.default_action}} <br> webview height: {{listitem.default_action.webview_height_ratio}}  <br> Messenger extension: false</span>
                                        <span v-if="card.imageaction[listindex] == false">Click action disabled</span>
                                    </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-divider v-if="card.message.attachment.payload.elements.length == listindex +1 && card.bottomlistbuttonstatus == true" :key="listindex+'d'" light></v-divider>
                                <v-divider v-if="listindex +1 < card.message.attachment.payload.elements.length" :key="listindex+'e'" light></v-divider>
                                </template>
                                <div v-if="card.bottomlistbuttonstatus == true">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" class="ma-1 text-xs-center primary--text">{{card.message.attachment.payload.buttons[0].type == 'element_share' ? 'Share':card.message.attachment.payload.buttons[0].title}}</div>
                                    </template>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'phone_number'">Phone number: {{card.message.attachment.payload.buttons[0].payload}}</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'element_share'">Sharble button</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'postback'">Link to response: {{card.message.attachment.payload.buttons[0].payload}}</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'web_url' && card.extentionstatus.bottombutton == true">url: {{card.message.attachment.payload.buttons[0].url}} <br> webview height: {{card.message.attachment.payload.buttons[0].webview_height_ratio}}  <br> Messenger extension: {{card.message.attachment.payload.buttons[0].messenger_extensions}}</span>
                                    <span v-if="card.message.attachment.payload.buttons[0].type == 'web_url' && card.extentionstatus.bottombutton == false">url: {{card.message.attachment.payload.buttons[0].url}} <br> webview height: {{card.message.attachment.payload.buttons[0].webview_height_ratio}}  <br> Messenger extension: false</span>
                                </v-tooltip>
                                </div>
                            </v-card>         
                        </v-flex>
                        <v-flex xs2 class="mt-2">
                            <v-layout>
                            <span v-if="button1 == index && card.type == 'generic'">{{card.currentelement+1+'/'+card.elementscount}}</span>
                            <v-btn
                                v-if="button1 == index && card.type == 'generic'"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat                                
                                @click="moveright(index)"
                            >
                            <v-icon>chevron_right</v-icon>                                    
                            </v-btn>
                            <!-- <v-btn
                                v-if="button1 == index"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                            >
                            <v-icon>edit</v-icon>                                    
                            </v-btn> -->
                            <v-btn
                                v-if="button1 == index"
                                class="mt-4"
                                small
                                color="grey"
                                fab
                                flat
                                @click="deleteCard(index)"
                            >
                            <v-icon>delete</v-icon>                                    
                            </v-btn>
                            </v-layout>                            
                        </v-flex>
                    </v-layout>
                </template>
                <v-card @mouseleave="hideqrbuttons" v-if="cards.length != 0" class="mt-4" flat style="border-radius: 8px;">
                    <template v-for="(quickreply,qrindex) in cquickreplies" >
                        <v-chip  @mouseover="showqrbuttons(qrindex)" :key="qrindex" small color="blue-grey lighten-5">
                            <div v-if="quickreply.content_type == 'user_phone_number'">User Phone number</div>
                            <div v-if="quickreply.content_type == 'user_email'">User Email</div>
                            <div v-if="quickreply.content_type == 'location'">Send location</div>
                            <div v-if="quickreply.content_type == 'text'">{{quickreply.title}}</div>
                            <v-btn class="mr-0" v-if="qrindex == quickreplyindex" flat icon small @click="editquickreply(qrindex)"><v-icon small color="grey">edit</v-icon></v-btn>
                            <v-btn class="mr-0" v-if="qrindex == quickreplyindex" flat icon small @click="deletequickreply(qrindex)"><v-icon small color="grey">delete</v-icon></v-btn>
                        </v-chip>
                    </template>
                    <v-btn v-if="cquickreplies.length <= 10" round flat outline small color="primary" @click="selectCardType($event,'quickreply')">+ Create Quick reply</v-btn>
                </v-card>                
            </v-flex>
        </v-layout>        
        <v-layout>
            <v-flex xs4 class="mt-3 ml-3">
                <div class="mt-3">.</div>
                <v-card class="mt-4" flat style="border-radius: 8px;">
                        <v-card-actions class="blue lighten-5 justify-space-between"> 
                             <v-btn @click="selectCardType($event,'template')" flat block color="primary"> + Create template</v-btn>
                        </v-card-actions>
                </v-card> 
            </v-flex>
            <v-flex xs8 class="ma-3">
                <div class="title font-weight-regular mt-3"> Create Broadcast message</div>
                     <v-card class="mt-4 blue lighten-5" flat style="border-radius: 8px;">
                        <v-card-actions v-if="templateIndex != null" class=" justify-space-between">          
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">   
                                <v-btn icon @click="selectCardType($event,'text')" v-on="on">
                                    <v-icon>notes</v-icon>
                                </v-btn>
                                </template>
                                <span>text</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">    
                                <v-btn icon @click="selectCardType($event,'button')" v-on="on">
                                    <v-icon>short_text</v-icon>
                                </v-btn>
                                </template>
                                <span>text with buttons</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">   
                                <v-btn icon @click="selectCardType($event,'image')" v-on="on">
                                    <v-icon >photo</v-icon>
                                </v-btn>
                                </template>
                                <span>image</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">    
                                <v-btn @click="selectCardType($event,'generic')" icon v-on="on">
                                    <v-icon>photo_library</v-icon>
                                </v-btn>
                                </template>
                                <span>Gallery</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">    
                                <v-btn icon @click="selectCardType($event,'list')" v-on="on">
                                    <v-icon >list</v-icon>
                                </v-btn>
                                </template>
                                <span>List</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">    
                                <v-btn icon @click="selectCardType($event,'audio')" v-on="on">
                                    <v-icon>audiotrack</v-icon>
                                </v-btn>
                                </template>
                                <span>audio</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">    
                                <v-btn icon @click="selectCardType($event,'video')" v-on="on">
                                    <v-icon>videocam</v-icon>
                                </v-btn>
                                </template>
                                <span>video</span>
                                </v-tooltip>
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">   
                                <v-btn icon @click="selectCardType($event,'file')" v-on="on">
                                    <v-icon>description</v-icon>
                                </v-btn>
                                </template>
                                <span>file</span>
                                </v-tooltip>                          
                                <!-- <v-tooltip top>
                                <template v-slot:activator="{ on }">   
                                <v-btn icon @click="selectCardType($event,'button')" v-on="on">
                                    <v-icon>link</v-icon>
                                </v-btn>
                                </template>
                                <span>link to another flow</span>
                                </v-tooltip>              -->
                        </v-card-actions>
                    </v-card>
            </v-flex>
        </v-layout>
        <v-menu v-model="bcastmenu"
                :close-on-click = "false"
                :position-x="x"
                :position-y="y"
                offset-x
                :close-on-content-click="false"
                :nudge-width="600">
            <v-card>
                <createtemplate v-if="cardtype == 'template'"></createtemplate>
                <edittemplate v-if="cardtype == 'edittemplate'"></edittemplate>
                <createtext v-if="cardtype == 'text'"></createtext>
                <createbutton v-if="cardtype == 'button'"></createbutton>
                <creategallery v-if="cardtype == 'generic'"></creategallery>
                <createlist v-if="cardtype == 'list'"></createlist>
                <createquickreply v-if="cardtype == 'quickreply'"></createquickreply>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'image'"></createmedia>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'video'"></createmedia>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'audio'"></createmedia>
                <createmedia v-bind:mediatype="cardtype" v-if="cardtype == 'file'"></createmedia>
            </v-card>
        </v-menu>   
    </v-card>
    </v-container>
</template>

<script>
import createtemplate from './Broadcast-message-createtemplate.vue'
import edittemplate from './Broadcast-message-edittemplate.vue'
import createtext from './Broadcast-message-createtext.vue'
import createbutton from './Broadcast-message-createbutton.vue'
import creategallery from './Broadcast-message-creategallery.vue'
import createlist from './Broadcast-message-createlist.vue'
import createmedia from './Broadcast-message-createmedia.vue'
import createquickreply from './Broadcast-message-createquickreply.vue'
import Vue from 'vue'
export default {
    components:{
        createtext,
        createbutton,
        creategallery,
        createlist,
        createmedia,
        createtemplate,
        edittemplate,
        createquickreply
    },
    data(){
        return{
            cardtype:null,
            readcardtype:[],
            x:0,
            y:0,
            expand:false,
            hover1:null,
            button1:false,
            gallerycardindex:0,
            totalgallerycards:null,
            quickreplyindex:null,
            mediatype:null
        }
    },
    methods:{
        selectCardType(event,type){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('abcastmenuStatusChange',status)
        },
        expandTemplate(index){             
            this.$store.dispatch('abcastTemplateIndexChange',{index})
        },
        editTemplateName(index,event,type){            
            this.$store.dispatch('abcastTemplateIndexChange',{index})
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            this.cardtype = type
            let status = true
            this.$store.dispatch('abcastmenuStatusChange',status)
        },
        deleteTemplate(index){            
            this.$store.dispatch('abcastdeleteTemplate',{index})
        },
        openmenu(index){
            this.hover1 = index
        },
        closemenu(){
            this.hover1 = null
        },
        showbuttons(index){
            this.button1 = index
        },
        hidebuttons(){
            this.button1 = null
        },
        moveright(index){
            if(this.cards[index].currentelement != this.cards[index].elementscount - 1)
            {
            this.cards[index].currentelement = this.cards[index].currentelement + 1
            }
        },
        moveleft(index){
            if(this.cards[index].currentelement != 0)
            {
            this.cards[index].currentelement = this.cards[index].currentelement - 1
            }
        },
        deleteCard(index){
            this.$store.dispatch('aupdatebcastMessage', {index})
        },
        showqrbuttons(qrindex){
           this.quickreplyindex = qrindex 
        },
        hideqrbuttons(){
            this.quickreplyindex = null
        },
        editquickreply(qrindex){

        },
        deletequickreply(qrindex){
             this.$store.dispatch('abcastdeletequickreply',{qrindex})
        }        
    },
    computed:{
        cMessages(){
            if(this.$store.state.bTemplateNames.length > 0)
            {
                return this.$store.state.bTemplateNames
            }
            else {
                return []
            }
            
        },
        bcastmenu(){
            return this.$store.state.bcastmenuStatus
        },
        cards(){
            if(this.$store.state.bTemplateindex != null)
            {   
                let index = this.$store.state.bTemplateindex
                let cards = this.$store.state.bTemplateNames[index].messages
                return cards
            }
            else {
                return []
            }
        },
        templateIndex(){
            return this.$store.state.bTemplateindex 
        },
        cquickreplies(){
            console.log(this.$store.state.bTemplateindex)
            console.log(this.$store.state.bTemplateNames)
            if(this.$store.state.bTemplateindex != null)
            {                
            let index = this.$store.state.bTemplateindex
            if(this.$store.state.bTemplateNames[index].quickreplies.qreplies.length > 0)
            {
            return this.$store.state.bTemplateNames[index].quickreplies.qreplies
            }
            else{
                return []
            }
            }
        }

    },
    created(){
       
    }
    
}
</script>


<style scoped>
*{ text-transform: none !important; }
</style>

